<template>
    <div class="user-profile-change-password-wrap">
        <div class="user-edit-profile-head">
            <h1 class="fs-17 bg-gray mb-20px p-3 radius-4 d-flex align-center justify-content-between">
                Email Settings
            </h1>
        </div>

        <div class="user-edit-profile-form">
            <el-form label-position="top">
                <div class="user-edit-profile-form-box mb-20px">
                    <el-row :span="24">
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full text-black lh-24">
                                    Promotional
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="Get emails to find out what's going on when you're not on dLab. You can turn them off whenever you want."
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="promotional" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full lh-24" :class="promotional ? 'text-black' : ''">
                                    Features &amp; Announcements
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="New products and feature updates, as well as occasional company announcements"
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="featuresAndAnnouncements" :disabled="promotional == false ? true : false" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full" :class="promotional ? 'text-black' : ''">
                                    The dLab
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="An email rounding up the best news, entertainment, and culture from the world of software development"
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="theOverflow" :disabled="promotional == false ? true : false" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <div class="user-edit-profile-form-box mb-20px">
                    <h4 class="form-title">Research</h4>
                    <el-row :span="24">
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full text-black lh-24">
                                    Invitations
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="Invitations to participate in surveys, usability tests, and more. Only a few per year."
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="invitations" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <div class="user-edit-profile-form-box mb-20px">
                    <h4 class="form-title">Question &amp; Answer</h4>
                    <el-row :span="24">
                        <el-col :span="24">
                            <div class="user-edit-email-box">
                                <el-form-item label="Email Address">
                                    <el-input
                                        v-model="emailAddress"
                                        placeholder="Email Address"
                                        class="input-with-select"
                                        size="large"
                                        >
                                        <template #append>
                                            <el-button class="btn theme-btn">save</el-button>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>

                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full text-black lh-24">
                                    Tips &amp; Reminders
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="Timely advice and reminders to help you make the most of our features"
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="tipsReminders" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full text-black lh-24">
                                    Inbox
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="Answers to your questions, comments, chat notifications, and more"
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-button-group size="small">
                                    <el-button size="small">Off</el-button>
                                    <el-button size="small" type="primary">3 hrs</el-button>
                                    <el-button size="small">Daily</el-button>
                                    <el-button size="small">Weekly</el-button>
                                </el-button-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full text-black lh-24">
                                    Community Milestones
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="Notifications about bounties, reputation and more. Hint: sometimes involves swag."
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="communityMilestones" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full text-black lh-24">
                                    Community Digests
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="Our best community content of the week"
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-button size="small">Manage</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full text-black lh-24">
                                    Question Subscriptions
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="New questions that match your criteria"
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-button size="small">Manage</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <div class="d-flex gap-1 align-center w-full text-black lh-24">
                                    Company Alerts
                                    <el-tooltip
                                        class="dlab-tooltip"
                                        effect="dark"
                                        content="Content from companies you follow"
                                        placement="top"
                                    >
                                        <el-icon><InfoFilled /></el-icon>
                                    </el-tooltip>
                                </div>
                                <el-button-group size="small">
                                    <el-button size="small" type="primary">Off</el-button>
                                    <el-button size="small">Weekly</el-button>
                                </el-button-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                
                <el-row>
                    <el-col>
                        <el-button class="btn theme-btn user-profile-save-btn">Save Changes</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
import { InfoFilled } from '@element-plus/icons-vue'

export default {
    name: 'UserProfileEmailSetting',
    components: {
        InfoFilled
    },
    data() {
        return {
            promotional: true,
            featuresAndAnnouncements: false,
            theOverflow: false,
            invitations: false,
            tipsReminders: true,
            emailAddress: 'example@gmail.com',
            communityMilestones: true
        }
    }
}
</script>